import styled from "styled-components";

interface Props {
    title?: string,
}

export function Status({ title }: Props) {

    let color = "";
    let backgroundColor = "";

    switch (title) {
        case "Pendente N1":
        case "Pendente N2":
            color = "#c62828";
            backgroundColor = "#ffebee";
            break;
        case "Aprovado N1":
            color = "#2e7d32";
            backgroundColor = "#e8f5e9";
            break;
        case "Aprovado N2":
            color = "#1b5e20";
            backgroundColor = "#c8e6c9";
            break;
    }
    return (
        <StyledStatus style={{ color, backgroundColor }}>{title}</StyledStatus>
    )
}

const StyledStatus = styled.span`
    display: inline-block;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
`;